import { datadogRum } from '@datadog/browser-rum'
import packageInfo from '../../package.json'
import { getCookieAuthorizationToken, getCookieProfileUser } from '@wiggot/auth'

const initDatadogRecording = (
  applicationId: string,
  clientToken: string,
  stage: string
) => {
  datadogRum.init({
    applicationId,
    clientToken,
    site: 'datadoghq.com',
    service: 'wiggot',
    env: stage,
    sessionSampleRate: 20,
    sessionReplaySampleRate: 20,
    version: packageInfo.version,
    trackUserInteractions: true,
    trackSessionAcrossSubdomains: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input'
  })
  datadogRum.startSessionReplayRecording()
  setDatadogUser()
}

const setDatadogUser = () => {
  try {
    const token = getCookieAuthorizationToken()
    const userLogin = getCookieProfileUser()
    if (token && userLogin) {
      try {
        const user = {
          id: userLogin?.userId,
          name: userLogin?.fullname,
          email: userLogin?.email
        }
        datadogRum.setUser(user)
      } catch (error) {
        console.log(error)
      }
    }
  } catch (error) {
    console.log(error)
  }
}

const validateDatadogSession = () => {
  if (datadogRum.getInternalContext()) {
    setDatadogUser()
    return true
  }
  return false
}

export { initDatadogRecording, setDatadogUser, validateDatadogSession }
